const DEFAULTS = {
  navSelector: '.sticky-navbar__link',
  activeClass: 'sticky-navbar__link--active',
  sectionLink: '[data-section-link]',
};

export default class stickyNav {
  constructor(el, options) {
    Object.assign(this.options = {}, DEFAULTS, options);
    this.el = el;
    this.elHeight = el.offsetHeight;
    this.navContentMap = this.buildMap();
    this.sectionLinks = document.querySelectorAll(this.options.sectionLink);

    [...this.navContentMap.values()].forEach(link => {
      const section = document.getElementById(link.hash.substr(1));
      this.createInViewObserver(section);
      section.style.scrollMarginTop = `${this.elHeight}px`;
    });

    this.addScrollMarginTopToSectionLinks();
  }

  /**
   * Builds a Map of content sections to anchors to reduce calls to querySelector/getElementById later
   * @return {Map} A Map linking element[id=ID]->a[href=#ID]
   */
  buildMap() {
    const map = new Map();
    this.el.querySelectorAll(this.options.navSelector).forEach(link => {
      map.set(document.getElementById(link.hash.substr(1)), link);
    });
    return map;
  }

  /**
   * Creates and observes an element.
   * When the element hits a threshold,
   * all content in this.navContentMap get evaluated to identify
   * which section the visitor has scrolled to.
   * @param  {HTMLElement} contentSection [description]
   */
  createInViewObserver(contentSection) {
    const inViewObserver = new IntersectionObserver(() => this.evalActiveContent(), {
      threshold: [0, 0.5, 1],
    });
    inViewObserver.observe(contentSection);
  }

  /**
   * Sorts elements by 'closest to top of viewport',
   * Chooses the closest element as the "active" content,
   * and sets the mapped navItem classes to match
   * @return {[type]} [description]
   */
  evalActiveContent() {
    const activeContentSection = [...this.navContentMap.keys()].sort((a, b) =>
      Math.abs(a.getBoundingClientRect().top) - Math.abs(b.getBoundingClientRect().top))[0];
    this.setActiveNavItem(this.navContentMap.get(activeContentSection));
  }

  /**
   * Adds the activeClass to the active navItem,
   * removes activeClass from all other navItems.
   */
  setActiveNavItem(activeNavItem) {
    activeNavItem.classList.add(this.options.activeClass);
    [...this.navContentMap.values()].forEach(link => {
      if (link !== activeNavItem) {
        link.classList.remove(this.options.activeClass);
      }
    });
  }

  /**
   * Add scroll margin top to section links to account for the subnav height
   */
  addScrollMarginTopToSectionLinks() {
    for (let i = 0; i < this.sectionLinks.length; i++) {
      this.sectionLinks[i].style.scrollMarginTop = `${this.elHeight + 16}px`;
    }
  }
}
